import { useEffect, useState } from 'react'
import Mousetrap from 'mousetrap'
import { useDispatch, useSelector } from 'react-redux'
import { findSelectedStudents, selectAll } from './features/classState/studentsSlice'
import { setBehaviour } from './features/behaviourControls/behaviourControlsSlice'
import { triggerBehaviour } from './features/classState/studentsSlice'

/**
 * A React component that sets up global keyboard shortcuts (hotkeys) to dispatch actions 
 * to modify student behavior states. The hotkeys trigger different behavioral actions 
 * for a selected group of students when specific keys are pressed.
 *
 * Hotkey bindings:
 * - "q": Dispatches a 'positive' behavior impulse.
 * - "w": Dispatches a 'neutral' behavior impulse.
 * - "e": Dispatches a 'negative' behavior impulse.
 * - "r": Dispatches an 'evoke' behavior impulse.
 *
 * This component does not render any UI elements; it exists solely for side effects.
 *
 * @returns {null} This component does not render anything.
 */
const Hotkeys = () => {
	const dispatch = useDispatch()
    const students = useSelector(findSelectedStudents)
    const [isAllSelected, setIsAllSelected] = useState(false)

    useEffect(() => {
        Mousetrap.bind("q", () => {
            dispatch(setBehaviour({ behaviour: 'positive', type: 'impulse', students }));
        });
        Mousetrap.bind("w", () => {
            dispatch(setBehaviour({ behaviour: 'neutral', type: 'impulse', students }));
        });
        Mousetrap.bind("e", () => {
            dispatch(setBehaviour({ behaviour: 'negative', type: 'impulse', students }));
        });
        Mousetrap.bind("r", () => {
            dispatch(setBehaviour({ behaviour: 'evoke', type: 'impulse', students }));
        });
        Mousetrap.bind("s", () => {
            console.log("Pressed S Hotkey");
            dispatch(triggerBehaviour({ behaviour: 'Idle', type: 'behaviour', students }));
        });
        Mousetrap.bind("a", () => {
            console.log("Pressed A Hotkey");
            // Toggle the state between selecting and deselecting all
            setIsAllSelected(prevState => {
                const newState = !prevState;
                dispatch(selectAll(newState)); // Dispatch based on the new state
                return newState;
            });
        });

        // Cleanup on component unmount
        return () => {
            Mousetrap.unbind("q");
            Mousetrap.unbind("w");
            Mousetrap.unbind("e");
            Mousetrap.unbind("r");
            Mousetrap.unbind("s");
        };
    }, [dispatch, students]); // Effect re-runs when dispatch or students change

    return null
}

export default Hotkeys
